export default "__VITE_ASSET__Cst_cO95__"